import loadable from '@loadable/component'

export const SolicitationTable = loadable(() => import('./SolicitationTable'))
export const SolicitationTableItem = loadable(
  () => import('./SolicitationTableItem')
)
export const SolicitationStatus = loadable(() => import('./SolicitationStatus'))
export type {
  SolicitationTableHeaders,
  SolicitationTableProps
} from './SolicitationTable'
export type { SolicitationTableItemProps } from './SolicitationTableItem'
export type { SolicitationStatusProps } from './SolicitationStatus'
export { default as solicitationTableMocks } from './__mocks__/SolicitationTable.mock'
